/**
 * Blog single: native share fallback.
 *
 * @package HelloElementorChild
 */

function initCamstBlogSingleShare(scope) {
  var roots = [];

  if (!scope) {
    roots = Array.prototype.slice.call(document.querySelectorAll('[data-camst-blog-single-share]'));
  } else if (scope.matches && scope.matches('[data-camst-blog-single-share]')) {
    roots = [scope];
  } else {
    roots = Array.prototype.slice.call(scope.querySelectorAll('[data-camst-blog-single-share]'));
  }

  roots.forEach(function (button) {
    if (button.dataset.camstBlogSingleShareInit === '1') {
      return;
    }

    button.dataset.camstBlogSingleShareInit = '1';

    button.addEventListener('click', function () {
      var shareData = {
        title: document.title,
        url: window.location.href,
      };

      if (navigator.share) {
        navigator.share(shareData).catch(function () {});
        return;
      }

      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(shareData.url).then(function () {
          button.setAttribute('aria-label', 'Link copiato');
        });
      }
    });
  });
}

export function initCamstBlogSingle(scope) {
  initCamstBlogSingleShare(scope);
}

export function teardownCamstBlogSingle(scope) {
  if (!scope) {
    return;
  }

  var buttons = scope.matches && scope.matches('[data-camst-blog-single-share]')
    ? [scope]
    : Array.prototype.slice.call(scope.querySelectorAll('[data-camst-blog-single-share]'));

  buttons.forEach(function (button) {
    delete button.dataset.camstBlogSingleShareInit;
  });
}
